import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { lacCostLimitService } from '../../../services/LacCostLimitService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacCostLimitQuery(tenantName: string | undefined) {
  return useQuery({
    queryKey: lacQueryKeys.costLimit(tenantName ?? ''),
    enabled: Boolean(tenantName),
    queryFn: () => {
      if (!tenantName) {
        throw new Error('Missing tenant name');
      }
      return lacCostLimitService.getCostLimit(tenantName);
    },
  });
}

export function useLacCostLimitsQuery() {
  const { user } = useAuth();

  return useQuery({
    queryKey: lacQueryKeys.costLimits(),
    enabled: Boolean(user),
    queryFn: () => lacCostLimitService.listCostLimits(),
  });
}
